<template>
  <el-dialog :visible="isVisible" :width="isMobile ? '60%':'40%'" center :custom-class="isMobile ? 'cookie-dialog-mobile':'cookie-dialog'" :before-close="handleClose"
    :close-on-click-modal="true" :close-on-press-escape="true">
    <div :class="isMobile ? 'offText-mobile' : 'offText'">  
      <!-- <p>{{ $t('officialAlert.text') }}</p> -->
       <p>{{ $t('officialAlert.text')+' ' }}{{ country }}{{ $t('officialAlert.text1') }}</p>
      <!-- <p>IP地址: {{ ip }}</p> -->
      <!-- <p>国家: {{ country }}</p> -->
    </div>
    <div class="offText-btn">
      <div class="offText-btn-item">
        <el-button type="primary" @click="handleClose" :class="isMobile ? 'custom-button-mobile' : 'custom-button'">{{ $t('officialAlert.btnText')
          }}</el-button>
      </div>
      <div class="offText-btn-item">
        <el-button type="primary" @click="handleClose" :class="isMobile ? 'custom-button-mobile' : 'custom-button'">{{ $t('officialAlert.btnText1')
          }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import axios from 'axios';
export default {
  name: 'formPc',
  data() {
    return {
      isVisible: true,
      isMobile: false,
      ip: '',
      country: '',
    }
  },
  mounted() {
    this.isMobile = this.checkMobile();
    this.getVisitorInfo();
  },
  methods: {
    checkMobile() {
      const ua = navigator.userAgent
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    },
    handleClose() {
      // bus.$emit('inquiry-form', false)
      // 存储当前时间戳
      const timestamp = new Date().getTime();
      localStorage.setItem('alertClosedTimestamp', timestamp);
      this.isVisible = false;
    },
    async getVisitorInfo() {
      try {
        // 获取IP地址
        const ipResponse = await axios.get('https://ipapi.co/json/');
        this.ip = ipResponse.data.ip;

        // 根据IP获取国家信息
        const geoResponse = await axios.get(`https://ipapi.co/${this.ip}/json/`);
        this.country = geoResponse.data.country_name;
      } catch (error) {
        console.error('获取IP或国家信息失败:', error);
      }
    },
  }
}
</script>
<style scoped>
:deep(.cookie-dialog-mobile) {
  border-radius: 30px;
  padding: 5vw  2vw;
}
:deep(.cookie-dialog) {
  border-radius: 30px;
  padding: 1.5vw 1.5vw 2vw;
}

:deep(.el-dialog__header) {
  padding: 0 !important;
}

:deep(.el-dialog__body) {
  padding: 1px 25px 1px !important;
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  font-size: 1vw;
  color: #1e1e1e !important;
}
 :deep(.cookie-dialog-mobile .el-dialog__headerbtn .el-dialog__close) {
  font-size: 5vw;
  color: #1e1e1e !important;
}

:deep(.el-button--primary:hover) {
  background: #1e1e1e;
  border-color: #1e1e1e;
  color: #FFF;
}

:deep(.el-button--primary:focus) {
  background: #1e1e1e;
  border-color: #1e1e1e;
  color: #FFF;
}

:deep(.el-input.is-active el-input__inner),
:deep(.el-input__inner:focus) {
  border-color: #aaaaaa;
}

/* el-range-editor.is-active，.el-ramge-editor.i8-active:hover,.el-gelect .el-input.is-focug .elinput imerborder-color:#409EFF */
.custom-button-mobile {
  background: #1E1E1E;
  border-radius: 8px;
  font-size: 3vw;
  padding: 3vw 1vw;
  border-color: #1E1E1E;
  color: #fff;
  width: 100%;
}
.custom-button{
  background: #1E1E1E;
  border-radius: 10px;
  font-size: 0.8vw;
  padding: 0.8vw 1.5vw;
  border-color: #1E1E1E;
  color: #fff;
  width: 100%;
}
.offText {
  margin-top: 5%;
  font-size: 1vw;
}
.offText-mobile {
  margin-top: 5%;
  font-size: 3.5vw;
}

.offText p {
  text-align: center;
}

.offText-btn {
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
}
</style>